import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';
import { PremiumMenuIcon,PremiumCardIcon } from '../../../components/icons';
import ErrorIcon from '@material-ui/icons/Error';
import { data } from 'jquery';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  infoCard: {
    width: '100%',
    padding: "32px",
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center',
    borderRadius:24,
    boxShadow:'none',
    flexDirection:'column',
    paddingBottom:48
  },
  infoCardTitle: {
    fontSize: 28,
    letterSpacing: 'normal',
    marginTop:24,
    color:'#fff'
  },
  infoCardSecondTitle: {
    color: '#fff',
    fontSize: 20,
    letterSpacing: 'normal',
    marginTop:16
  },
  infoCardIcon: {
    fontSize: 64,
  }
}));
const PremimumInfoCard = (props) => {
  const {subscriptionStatus,price} = props;
  const classes = useStyles();
  const getCardDetails = ()=>{
    let data = {
      cardBg:null,
      imgBg:null,
      title:null,
      titleColor:'#fff',
      secondTitle:null,
      secondTitleColor:'#fff'
    }
    if(subscriptionStatus && subscriptionStatus.status && subscriptionStatus.subscriptionType){
      let status = subscriptionStatus.status;
      let type = subscriptionStatus.subscriptionType;
      if(status == "EXPIRED" && type === "FREE_TRIAL"){
        data.cardBg = '#fecdce';
        data.title = <><strong>Your Transport</strong>Book <strong>Free Trial has expired!</strong></>
        data.secondTitle = <>Complete the payment to continue accessing premium features.</>
        data.titleColor='#1f2940';
        data.secondTitleColor='#1f2940';
        data.error = true
      }else if(status === "EXPIRED" && type === "PAID"){
        data.cardBg = '#fecdce';
        data.title = <><strong>Your Transport</strong>Book <strong>Premium has expired!</strong></>
        data.secondTitle = <>Complete the payment to continue accessing premium features.</>
        data.titleColor='#1f2940';
        data.secondTitleColor='#1f2940';
        data.error = true
      }else if(status === "ACTIVE" && type === "FREE_TRIAL"){
        data.cardBg = '#1f2940';
        data.title = <><strong>Upgrade to Transport</strong>Book <strong>Premium</strong></>
        data.secondTitle = <>Upgrade to premium to access the <strong>Desktop App</strong> at {price} per year</>
        data.secondTitleColor='#fcda6f'
      }else if(status === "PROCESSING" && type === "PAID"){
        data.cardBg = '#1f2940';
        data.title = <><strong>Upgrade to Transport</strong>Book <strong>Premium</strong></>
        data.secondTitle = <>Upgrade to premium to access the <strong>Desktop App</strong> at {price} per year</>
        data.secondTitleColor='#fcda6f'
      }else if(status === "ACTIVE" && type === "PAID"){
        data.cardBg = '#0c8f64';
        data.title = <><strong>Hey! Welcome to Transport</strong>Book <strong>Premium</strong></>
        data.secondTitle = <>You now have full access to TransportBook on Desktop as well as mobile App.</>
      }
    }
    return data
  }
  return (
    <>
      <Paper className={classes.infoCard} style={{ backgroundColor: getCardDetails().cardBg ? getCardDetails().cardBg : 'inherit' }} >
        {getCardDetails() && getCardDetails().error?<ErrorIcon style={{color:'#de1c22',fontSize:64}}/>:<PremiumCardIcon className={classes.infoCardIcon} />}
        <Typography className={classes.infoCardTitle} style={{ color: getCardDetails().titleColor ? getCardDetails().titleColor : 'inherit' }}>
            {getCardDetails().title}
        </Typography>
        <Typography className={classes.infoCardSecondTitle} style={{ color: getCardDetails().secondTitleColor ? getCardDetails().secondTitleColor : 'inherit' }}>
            {getCardDetails().secondTitle}
        </Typography>
      </Paper>
    </>
  );
}
export default PremimumInfoCard;